import { render, staticRenderFns } from "./TestRecord.vue?vue&type=template&id=84474606&scoped=true"
import script from "./TestRecord.vue?vue&type=script&lang=js"
export * from "./TestRecord.vue?vue&type=script&lang=js"
import style0 from "./TestRecord.vue?vue&type=style&index=0&id=84474606&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84474606",
  null
  
)

export default component.exports